import { render, staticRenderFns } from "./MapInfo.component.vue?vue&type=template&id=56852a3c&scoped=true&"
import script from "./MapInfo.component.vue?vue&type=script&lang=ts&"
export * from "./MapInfo.component.vue?vue&type=script&lang=ts&"
import style0 from "./MapInfo.component.vue?vue&type=style&index=0&id=56852a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56852a3c",
  null
  
)

export default component.exports